// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cardDiv[data-v-7a81d6bc]{height:400px;overflow:auto}", ""]);
// Exports
module.exports = exports;
